module.exports = __webpack_public_path__ + "fonts/KaTeX_Size4-Regular.e418bf2.woff2";